import { TableContainer } from "@mui/material";
import { DataGrid, GridRowHeightReturnValue } from "@mui/x-data-grid";

import { dataGridServerStyles } from "../../../common/providers/theme/design-tokens/DataGrid/dataGridServer.styles";
import { DEFAULT_COLUMN_HEADER_HEIGHT } from "../../../common/variables/common";
import { TablePaperContainer } from "../../../leak-finder/components/VideosTable";
import { useDeviceTableColumns } from "../hooks/useDeviceTableColumns";
import { useDeviceTableRows } from "../hooks/useDeviceTableRows";
import { DEVICES_TABLE_LIMIT } from "../hooks/useGetDevices";
import DevicesTableNoRowsOverlay from "./DevicesTableNoRowsOverlay";
import { useNavigate } from "react-router-dom";

const DevicesTable = (): JSX.Element => {
  const { rows, loading } = useDeviceTableRows();

  const { columns } = useDeviceTableColumns();
  const navigate = useNavigate();

  return (
    <TableContainer component={TablePaperContainer}>
      <DataGrid
        sx={{
          ...dataGridServerStyles.sx,
          cursor: "pointer",
        }}
        columnHeaderHeight={DEFAULT_COLUMN_HEADER_HEIGHT}
        pageSizeOptions={[25, 50, 100]}
        rows={rows}
        onRowClick={params =>
          navigate(`/device/${encodeURIComponent(params.row.rowId)}`, {
            state: { deviceDatum: params.row },
          })
        }
        columns={columns}
        loading={loading}
        slots={{
          noRowsOverlay: DevicesTableNoRowsOverlay,
        }}
        getRowHeight={(): GridRowHeightReturnValue => "auto"}
        disableRowSelectionOnClick
        hideFooterSelectedRowCount
        getRowId={(row: { rowId?: string }): string => row?.rowId ?? ""}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: DEVICES_TABLE_LIMIT,
            },
          },
          sorting: {
            sortModel: [
              {
                field: "skuNumber",
                sort: "asc",
              },
            ],
          },
        }}
        sortingOrder={["asc", "desc"]}
      />
    </TableContainer>
  );
};

export default DevicesTable;
